export default __webpack_public_path__ + "static/media/success-error-background.eac04841.jpg";